export default function (key) {
  let url = null;
  if (window.URL) {
    url = new URL(location.href);
  }
  if (url && url.searchParams) {
    return url.searchParams.get(key);
  }

  const query = window.location.search.substring(1);
  const vars = query.split('&');
  let pair = null;

  for (let i = 0, l = vars.length; i < l; i += 1) {
    pair = vars[i].split('=');
    if (pair[0] === key) {
      return pair[1];
    }
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/utils/getUrlParam.js